<template>
  <div>
    <!--begin::User-->
    <div>

      <div class="pb-5 d-flex justify-content-between">
        <h3 class="card-label">
          {{ $t('MENU.system_log_config') }}
          <span class="text-muted pt-2 font-size-sm d-block"></span>
        </h3>
      </div>
      <div class="row mt-5">
        <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-custom">
                  <div class="card-body row">
                      <div class="col-lg-12 mb-5">
                        <b-form-checkbox v-model="app_debug" size="lg" name="app_debug" switch>
                          App Debug
                        </b-form-checkbox>
                      </div>

                      <div class="col-lg-12 mb-5">
                        <b-form-checkbox v-model="sentry_logging" size="lg" name="sentry_logging" switch>
                          Sentry Logging
                        </b-form-checkbox>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          
        </div>
      </div>


      <div class="pl-0 pr-0">
        <div class="row">
          <div class="col-lg-6 mt-10">
            <button type="button" class="btn btn-primary mr-2" @click="save">{{ $t('save') }}</button>
          </div>
        </div>
      </div>
    </div>
    <!--end::User-->
  </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service";
import Vue from "vue";

export default {
  name: "from-system-log-config",
  data() {
    return {
      mainRoute: 'settings/company/system-log-config',
      app_debug: false,
      sentry_logging: false,
      isEditing: false,
      validation: null,
    };
  },

  methods: {

    async getData() {
      try {
        const response = await ApiService.get('settings/company/getCompany');
        const data = response.data.data;

        this.app_debug = data.app_debug;
        this.sentry_logging = data.sentry_logging;
        
      } catch (error) {
        this.$errorAlert(error);
      }
    },

    save() {
        ApiService.post(this.mainRoute, {
          app_debug: this.app_debug,
          sentry_logging: this.sentry_logging,
        })
        .then((response) => {
          this.validation = null;
          this.$successAlert(response.data.message);
        })
        .catch((error) => {
          Vue.prototype.$postStatus = true;
          this.$errorAlert(error);
          this.validation = error.response ? error.response.data.errors : null;
        });
      }
    },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$t("MENU.system_log_config")}]);
    this.getData();
  },
};
</script>


